<template>
<div>
    <!-- modal -->
    <b-modal id="lawPoNumberFormModal" centered size="lg" no-close-on-backdrop ref="lawPoNumberFormModal" :title="$t('lawPoNumber.info')" @close="clear()" body-class="py-2" :cancel-title="$t('others.cancel_title')" :ok-title="$t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-form>
                <b-row class="mt-2 mb-2">
                    <b-col class="col-md-12">
                        <validation-provider :name="$t('lawPoNumber.agent')" rules="required" v-slot="{ errors }">
                            <label for="law-po-number-agent-input">{{ $t('lawPoNumber.agent') }}</label>
                            <v-select id="law-po-number-agent-input" v-model="lawPoNumberAgentSelect" :options="lawPoNumberAgentOption" :get-option-label="$formatAgent" @input="setClientId" @search="onSearch" class="w-100 custom-v-select"></v-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col class="col-md-12">
                        <validation-provider :name="$t('lawPoNumber.no')" rules="required" v-slot="{ errors }">
                            <label for="law-po-number-no-input">{{ $t('lawPoNumber.no') }}</label>
                            <b-form-input id="law-po-number-no-input" v-model="no" :state="errors.length > 0 ? false : null" size="sm" maxlength="50" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawPoNumberList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            no: '',
            lawPoNumberAgentOption: [],
            lawPoNumberAgentSelect: null,
            clientId: 0,
            searchTimeout: null,
        }
    },
    methods: {
        setClientId(event) {
            if (event != null) {
                this.clientId = event.clientId
            } else {
                this.clientId = null;
            }
        },
        onSearch(search, loading) {
            if (search.length) {
                loading(true);
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    this.searchAgent(loading, search);
                }, 400);
            }
        },
        searchAgent(loading, search) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    clientName: search,
                    forAgentOrInvoice: 2,
                }
                const controller = {
                    name: 'ClientAccounting',
                    actionName: 'GetLawClientAccountingByLawClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.lawPoNumberAgentOption = response.data.clientList
                    loading(false)
                })
            } else {
                loading(false)
            }
        },
        clear() {
            this.id = 0
            this.no = ''
            this.lawPoNumberAgentOption = []
            this.lawPoNumberAgentSelect = null
            this.clientId = 0
        },
        showInfo(id) {
            this.$refs['lawPoNumberFormModal'].show()
            this.clear()
            this.id = id
            const data = {
                id: this.id
            }
            const controller = {
                name: 'LawPoNumber'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.no = response.data.lawPoNumber.no
                    if (response.data.lawPoNumber.clientAccountingId > 0) {
                        const clientAccountingData = {
                            clientAccountingId: response.data.lawPoNumber.clientAccountingId
                        }
                        const clientAccountingController = {
                            name: 'ClientAccounting',
                            actionName: 'GetClientAccountingByClientName'
                        }
                        const clientAccountingPayload = {
                            data: clientAccountingData,
                            controller: clientAccountingController
                        }
                        this.$store.dispatch('moduleAuth/customService', clientAccountingPayload).then((clientAccountingResponse) => {
                            this.lawPoNumberAgentOption = clientAccountingResponse.data.clientList
                            this.lawPoNumberAgentSelect = clientAccountingResponse.data.clientList[0]
                            this.clientId = clientAccountingResponse.data.clientList[0].clientId
                        })
                    } else {
                        this.lawPoNumberAgentOption = []
                        this.lawPoNumberAgentSelect = null;
                    }
                } else {
                    this.$bvModal.hide('lawPoNumberFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                no: this.no,
                clientAccountingId: this.lawPoNumberAgentSelect ? this.lawPoNumberAgentSelect.clientAccountingId : null,
            }
            const controller = {
                name: 'LawPoNumber'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.getLawPoNumberList()
                            this.$SaveAlert()
                            this.$bvModal.hide('lawPoNumberFormModal')
                        } else {
                            this.$WarningAlert(this.$t("alerts." + response.data.resultMessage))
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
    white-space: pre-wrap !important;
}
</style>
